import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import NavItem, { StateFromProps, OwnProps } from './NavItem';
import RootState from '../../../modules/rootState';
import * as appUI from '../../../modules/uis/app';

const mapStateToProps = (state: RootState, props: OwnProps): StateFromProps => ({
    // ui
    hasDirtyData: appUI.selectors.getHasDirtyData(state)
});

export default withRouter<OwnProps, any>(connect<StateFromProps, {}, OwnProps>(mapStateToProps)(NavItem));


// WEBPACK FOOTER //
// ./src/components/shared/NavItem/NavItem.container.ts